import type { FC, ReactNode } from 'react'
import type { TocItem } from '@/lib/toc'

interface TableOfContentsProps {
    items: TocItem[]
}

export const TableOfContents: FC<TableOfContentsProps> = ({ items }): ReactNode => {
    if (items.length === 0) return null

    return (
        <nav aria-label='Table of contents'>
            <p className='text-xs font-semibold uppercase tracking-wider text-foreground'>
                On this page
            </p>

            <ul className='mt-4 space-y-1 border-l border-border'>
                {items.map(item => (
                    <li key={item.id}>
                        <a
                            href={`#${item.id}`}
                            className='-ml-px block border-l-2 border-transparent py-1 pl-4 text-sm leading-snug text-muted-foreground transition-colors hover:border-l-primary hover:text-foreground'
                        >
                            {item.text}
                        </a>
                    </li>
                ))}
            </ul>
        </nav>
    )
}
